module.exports = __webpack_public_path__ + "media/images/new/mobile/icons/arrow_right-62695413cdf6f5db798aa5f6b167cd69.png";